import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Token + user are kept in localStorage so the session persists across PWA
// launches, tab closes and app restarts (essential for a mobile-installed
// PWA experience). XSS remains the biggest risk — mitigated by strict CSP
// on the frontend and JWT expiration on the backend.
const TOKEN_KEY = "sbf_token";
const USER_KEY = "sbf_user";

const storage = typeof window !== "undefined" ? window.localStorage : null;

api.interceptors.request.use((config) => {
  const token = storage?.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  saveSession: (token, user) => {
    storage?.setItem(TOKEN_KEY, token);
    storage?.setItem(USER_KEY, JSON.stringify(user));
  },
  getUser: () => {
    const u = storage?.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  },
  getToken: () => storage?.getItem(TOKEN_KEY) || null,
  logout: () => {
    storage?.removeItem(TOKEN_KEY);
    storage?.removeItem(USER_KEY);
    // Also clear any residual sessionStorage tokens from previous builds
    try {
      window.sessionStorage?.removeItem(TOKEN_KEY);
      window.sessionStorage?.removeItem(USER_KEY);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.debug("legacy sessionStorage cleanup skipped:", err?.message);
      }
    }
  },
};

// Migration: if the user is currently signed in via the OLD sessionStorage
// build, copy their token into localStorage so the upgrade is seamless.
if (storage && typeof window !== "undefined") {
  try {
    const legacyToken = window.sessionStorage?.getItem(TOKEN_KEY);
    const legacyUser = window.sessionStorage?.getItem(USER_KEY);
    if (legacyToken && !storage.getItem(TOKEN_KEY)) {
      storage.setItem(TOKEN_KEY, legacyToken);
      if (legacyUser) storage.setItem(USER_KEY, legacyUser);
    }
    if (legacyToken) {
      window.sessionStorage.removeItem(TOKEN_KEY);
      window.sessionStorage.removeItem(USER_KEY);
    }
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.debug("legacy sessionStorage migration skipped:", err?.message);
    }
  }
}

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const base64 = result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
